import { categories } from "../../../../common/data/olxCategories";
const DetailsTab = ({partDetails}) => {
  const handleYearSpan = (yearStart, yearEnd) => {
    if (yearStart == null || yearEnd == null) {
      return "N/A";
    }

    if (yearStart == yearEnd) {
      return yearStart;
    }

    return yearStart + " - " + yearEnd;
  }
  const handleLocation = (location) => {
    if (location == null) {
      return "N/A";
    }
    if (location == "NA AUTU" || location == "NA AUTU ") {
      return location + " - " + partDetails.originVehicle;
    }
    return location;
  }

    return(        
        <div className="table-responsive">
        <table className="table mb-0">
          <tbody>
            <tr>
              <th scope="row" style={{ width: "200px" }}> Kataloški broj: </th>
              <td>{partDetails.catalogNumber}</td>
            </tr>
            <tr>
              <th scope="row">Strana:</th>
              <td>{partDetails.position == null ? "N/A" : partDetails.position}</td>
            </tr>
            <tr>
              <th scope="row">Lokacija:</th>
              <td>{handleLocation(partDetails.location)}</td>
            </tr>
            <tr>
              <th scope="row">Boja:</th>
              <td>{partDetails.color == null ? "N/A" : partDetails.color}</td>
            </tr>
            <tr>
              <th scope="row">Godište</th>
              <td>{handleYearSpan(partDetails.yearStart, partDetails.yearEnd)}</td>
            </tr>
            <tr>
              <th scope="row">OLX kategorija</th>
              <td>{categories.find(item => item.value == partDetails.categoryId).label}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
};

export default DetailsTab;